import React, { useState, useEffect } from "react";
import "./../styles/FeedbackStyles.css";
import feedbackImage from "./../../../assets/images/OurServices/Mask group.svg";
import thankskImage from "./../../../assets/images/OurServices/Group 41719.png";
import close from "./../../../assets/images/OurServices/Vector.svg";
import backButton from "./../../../assets/images/OurServices/Group 41721.png";
import SliderComponent from "./SliderComponent";
import strings from "../../../utils/Strings";
import { useApi } from "../../../service/ApiContext";
import Logger from "../../../utils/Logger";
import Loader, { LocalStorage } from "./../../../utils/Utils";
import { FeedbackResponse } from "../data/api/response/FeedbackResponse";

const commonMarks = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
];

const FeedbackModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [selectedOption, setSelectedOption] = useState<string>("yes"); //Initially Selected Value
  const [jozunaRating, setJozunaRating] = useState<number>(10);
  const [videoRating, setVideoRating] = useState<number>(10);
  const [projectRating, setProjectRating] = useState<number>(10);
  const [service, setService] = useState<string>("JOZUNA: The Assessment");
  const [suggestion, setSuggestion] = useState<string>("");
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isThankYouVisible, setIsThankYouVisible] = useState<boolean>(false);
  const [thanksMessage, setThanksMessage] = useState("");

  const handleButtonClick = (value: string) => {
    setSelectedOption(value);
  };

  const handleSubmit = async () => {
    await Feedback();
  };

  const api = useApi();

  const Feedback = async () => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.post<FeedbackResponse>("/services/feedback", {
        selectedOption,
        jozunaRating,
        videoRating,
        projectRating,
        service,
        suggestion,
      });

      if (response.data.detail !== null) {
        setThanksMessage(response.data.detail);
        setIsSubmitted(true);
        setIsThankYouVisible(true);
      }

      if (isThankYouVisible) {
        onClose();
      }
    } catch (error) {
      Logger.error("Error submitting feedback:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  // Close the thank you modal after 5 seconds
  useEffect(() => {
    if (isThankYouVisible) {
      const timer = setTimeout(() => {
        setIsThankYouVisible(false);
        onClose(); // Close the modal after 5 seconds
      }, 3000); // 5000 milliseconds = 5 seconds

      return () => clearTimeout(timer); // Cleanup the timeout when the component unmounts or isThankYouVisible changes
    }
  }, [isThankYouVisible, onClose]);

  return (
    <div className="F_modal-overlay">
      {isThankYouVisible ? (
        <div className="thank-you-modal">
          <div className="thank-you-box">
            <button className="F_close-button" onClick={onClose}>
              <img src={close} alt="close" />
            </button>
            {/* Image on top */}
            <img
              src={thankskImage}
              alt="Thank you"
              className="thank-you-image"
            />
            {/* Thank you message */}
            <div className="thank-you-message">
              <h2>{thanksMessage}</h2>
            </div>
          </div>
        </div>
      ) : (
        <div className="modal_content">
          <div className="modal-left">
            {/* <img src={feedbackImage} alt="Feedback" className="background-image" /> */}
            <div className="overlay-text">
              <h2>Do you have feedback for us?</h2>
              <h2>We are listening!</h2>
            </div>
            {/* <img src={backButton} alt='back' /> */}
          </div>

          <div className="modal-right">
            <button className="F_close-buttons" onClick={onClose}>
              <img src={close} alt="close" />
            </button>
            <p style={{ fontFamily: "Mazzard", fontSize: "16px" }}>
              Do you think you are improving professionally?
            </p>
            <div className="button-group">
              <button
                className={`btn-option ${
                  selectedOption === "yes" ? "selected" : ""
                }`}
                onClick={() => handleButtonClick("yes")}
              >
                Yes
              </button>
              <button
                className={`btn-option ${
                  selectedOption === "partially" ? "selected" : ""
                }`}
                onClick={() => handleButtonClick("partially")}
              >
                Partially
              </button>
              <button
                className={`btn-option ${
                  selectedOption === "no" ? "selected" : ""
                }`}
                onClick={() => handleButtonClick("no")}
              >
                No
              </button>
            </div>

            <p style={{ fontFamily: "Mazzard", fontSize: "16px" }}>
              How would you rate JOZUNA?
            </p>
            <SliderComponent
              label="JOZUNA"
              value={jozunaRating}
              onChange={(e, newValue) => setJozunaRating(newValue as number)}
              marks={commonMarks}
              min={1}
              max={10}
            />

            <p style={{ fontFamily: "Mazzard", fontSize: "16px" }}>
              How would you rate Video Based Learning Essentials?
            </p>
            <SliderComponent
              label="Video Based Learning Essentials"
              value={videoRating}
              onChange={(e, newValue) => setVideoRating(newValue as number)}
              marks={commonMarks}
              min={1}
              max={10}
            />

            <p style={{ fontFamily: "Mazzard", fontSize: "16px" }}>
              How would you rate Project Based Industry Training?
            </p>
            <SliderComponent
              label="Project Based Industry Training"
              value={projectRating}
              onChange={(e, newValue) => setProjectRating(newValue as number)}
              marks={commonMarks}
              min={1}
              max={10}
            />
            <p style={{ fontFamily: "Mazzard", fontSize: "16px" }}>
              Which one of the services do you find most enjoyable?
            </p>
            <select
              className="feed_select"
              value={service}
              onChange={(e) => setService(e.target.value)}
            >
              <option value="JOZUNA: The Assessment">
                JOZUNA: The Assessment
              </option>
              <option>Video Based Learning Essentials</option>
              <option>Project Based Industry Training</option>
              <option>Expert Driven Live Sessions</option>
            </select>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <p style={{ fontFamily: "Mazzard", fontSize: "15px", margin: 0 }}>
                Do you have any suggestions to make our platform better?
              </p>
              <p style={{ fontFamily: "Mazzard", fontSize: "15px", margin: 0 }}>
                {suggestion.length}/500
              </p>
            </div>
            <div>
              <textarea
                maxLength={500}
                className="form-control feed_textarea"
                value={suggestion}
                onChange={(e) => setSuggestion(e.target.value)}
                rows={9} // Adjust the number of rows based on your needs
              ></textarea>
            </div>
            <button className="submit-button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedbackModal;
